import { format, parseISO } from 'date-fns';
import PropTypes from 'prop-types';

import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import Divider from '@zenbusiness/zui/Divider';
import Grid from '@zenbusiness/zui/Grid';
import Skeleton from '@zenbusiness/zui/Skeleton';
import Text from '@zenbusiness/zui/Text';

import * as Styled from '../OrderView.styles';

const LOCALIZED_TEXT = {
  plan: 'orderView.details.plan',
  product: 'orderView.details.product',
  heading: 'orderView.details.heading',
  startedOn: 'orderView.details.startedOn',
  renewsOn: 'orderView.details.renewsOn',
  purchasedOn: 'orderView.details.purchasedOn',
  chargedTo: 'orderView.details.chargedTo'
};

const Details = ({
  loading,
  isPlan,
  termEndDate,
  createdDatetime,
  cardUsed
}) => {
  const { formatMessage: fm } = useIntl();

  return (
    <Styled.DetailsRoot>
      <Grid
        container
        direction="column"
      >
        <Grid item>
          <Text variant="body1" fontWeight="bold">
            {isPlan
              ? fm({ id: LOCALIZED_TEXT.plan })
              : fm({ id: LOCALIZED_TEXT.product })}
            {' '}
            <FormattedMessage id={LOCALIZED_TEXT.heading} />
          </Text>
        </Grid>
        <Grid item>
          <Divider />
        </Grid>
        {loading ? (
          <Grid item>
            <Skeleton variant="rectangular" height={isPlan ? 200 : 100} />
          </Grid>
        ) : (
          <>
            {isPlan ? (
              <>
                <Styled.DetailsRow>
                  <Text variant="body1" fontWeight="bold"><FormattedMessage id={LOCALIZED_TEXT.startedOn} /></Text>
                  <Text>{format(parseISO(createdDatetime), 'MMMM do, yyyy')}</Text>
                </Styled.DetailsRow>
                {termEndDate && (
                  <Styled.DetailsRow>
                    <Text variant="body1" fontWeight="bold"><FormattedMessage id={LOCALIZED_TEXT.renewsOn} /></Text>
                    <Text>{format(parseISO(termEndDate), 'MMMM do, yyyy')}</Text>
                  </Styled.DetailsRow>
                )}
              </>
            ) : (
              <Styled.DetailsRow>
                <Text variant="body1" fontWeight="bold"><FormattedMessage id={LOCALIZED_TEXT.purchasedOn} /></Text>
                <Text>{format(parseISO(createdDatetime), 'MMMM do, yyyy')}</Text>
              </Styled.DetailsRow>
            )}
            <Styled.DetailsRow>
              <Text variant="body1" fontWeight="bold"><FormattedMessage id={LOCALIZED_TEXT.chargedTo} /></Text>
              <Text>{cardUsed}</Text>
            </Styled.DetailsRow>
          </>
        )}
      </Grid>
    </Styled.DetailsRoot>
  );
};

Details.propTypes = {
  isPlan: PropTypes.bool.isRequired,
  termEndDate: PropTypes.string,
  createdDatetime: PropTypes.string.isRequired,
  cardUsed: PropTypes.string.isRequired,
  loading: PropTypes.bool
};

export default Details;
